import CustomComponent from "../CustomComponent";

export class TestWebComponent extends CustomComponent {
  static key = 'lta-test-web-component';

  constructor() {
    super();
    this.state = { count: 0 };
    this._onClick = this._onClick.bind(this);
  }

  static get observedAttributes() {
    return ['title', 'count'];
  }

  style() {
    return `
        .card {
          background-color: #fff;
          padding: 10px;
          margin: 10px;
          box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
          border: 1px solid #e0e0e0;
          border-radius: 10px;
        }
        .carousel-v2-wrapper {
          display: flex;
          flex-direction: column;
        }
    `;
  }

  render(childrenHTML) {
    const { title } = this.props;
    const { count } = this.state;
    return `
      <div class="card">
        ${title ? `<h1>${title}</h1>` : ''}
        <p>Count: ${count}</p>
        <button id="incBtn">Increment</button>
        ${childrenHTML}
      </div>
    `;
  }

  afterRender() {
    this.querySelector('#incBtn')?.addEventListener('click', this._onClick);
  }

  beforeUnload() {
    this.querySelector('#incBtn')?.removeEventListener('click', this._onClick);
  }

  _onClick() {
    this.setState({ count: this.state.count + 1 });
  }
}

// How to use: 

// <lta-test-web-component title="Hello World">
//   <p>This is inside the body slot</p>
// </lta-test-web-component>

export default TestWebComponent;